import request from '@/request'
export function getList(data) {
    return request({	//文章列表
        url: 'article/list',
        method: 'POST',
        data: data
    })
}
// export function getChildList(params) {
//     return request({	//子列表
//         url: 'site/article/child/list',
//         method: 'get',
//         params: params
//     })
// }
// export function details(params) {
//     return request({
//         url: `site/article/${params}`,
//         method: 'get'
//     })
// }
export function menuList(params) {
    return request({	//顶部菜单栏目
        url: `menu/tree`,
        method: 'get',
        params: params
    })
}
export function imgList(params) {
    return request({
        url: `oss/listByIds/` + params.id ,
        method: 'get',
    })
}

// ========== 多语言降级工具：先查目标语言，空则查中文 ==========
// menuId: 目标语言的菜单id（如英文id）
// langKey: 目标语言码（"zh"|"en"|"jp"|"kor"）
// zhId: 对应中文的菜单id（用于降级查中文）
// 返回：最终文章数组（已降级处理）
export async function fetchWithFallback(menuId, langKey, zhId) {
    if (!menuId) return [];
    // 先查目标语言
    const res = await getList({ menuId, language: langKey });
    let list = res && res.data ? res.data : [];

    // 降级：目标语言无内容 && 不是中文 && 有 zhId
    if (list.length === 0 && langKey !== "zh" && zhId) {
        const zhRes = await getList({ menuId: zhId, language: "zh" });
        list = zhRes && zhRes.data ? zhRes.data : [];
    }

    return list;
}